import _ from 'lodash';
import PropTypes from 'prop-types';

const Label = (props) => {

    const { children, type, id, small } = props;

    switch (type) {
        case 'green':
            return (
                <p className={ small ? 'apartment-type-label-green-small' : 'apartment-type-label-green'} id={id}>
                    {_.upperCase(children)}
                </p>
            );
        case 'white':
            return (
                <p className={ small ? 'apartment-type-label-white-small' : 'apartment-type-label-white'} id={id}>
                    {_.upperCase(children)}
                </p>
            );
        default:
            return (
                <p className={ small ? 'apartment-type-label-small' : 'apartment-type-label' } type={type} id={id}>
                    {_.upperCase(children)}
                </p>
            );
    }
};

Label.propTypes = {
    children: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
    type: PropTypes.string,
    id: PropTypes.string,
    small: PropTypes.bool,
};

export default Label;
